import { render } from "./AnalyticsPieChart.vue?vue&type=template&id=5cc773d7&scoped=true"
import script from "./AnalyticsPieChart.vue?vue&type=script&lang=ts"
export * from "./AnalyticsPieChart.vue?vue&type=script&lang=ts"

import "./AnalyticsPieChart.vue?vue&type=style&index=0&id=5cc773d7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5cc773d7"

export default script